import { Injectable } from '@angular/core';
import {genesisServerUrl} from './app.config';
import {
    HttpClient, HttpHeaders 
} from '@angular/common/http';
import { LocalStorageService } from '../services/localstorage.service';

@Injectable({
    providedIn: 'root'
})
export class GenesisService {
    constructor(private localStorageService: LocalStorageService, private http: HttpClient) { }

    getUserRecentTransactions(page: number, limit: number) {
        const httpOptions = {
            headers: new HttpHeaders({
                token: this.getAuthToken()
            })
        };
    
        return this.http.get<any>(
            `${genesisServerUrl}dashboard/getUserRecentTransactions?page=${page}&limit=${limit}`,
            httpOptions
        );
    }
    
    getAuthToken() {
        const token = this.localStorageService.getItem('token');

        return token ? token : '';
    }

    getNewNodePredefinedData() {
        const httpOptions = {
            headers: new HttpHeaders({
                token: this.getAuthToken()
            })
        };

        return this.http.get<any>(
            `${genesisServerUrl}getNewNodePredefinedData`,
            httpOptions
        );
    }

    getIpLocation() {
        const httpOptions = {
            headers: new HttpHeaders({
                token: localStorage.getItem('token') as string
            })
        };

        return this.http.get<any>(`${genesisServerUrl}getIpLocation`, httpOptions);
    }

    getCredRate() {
        return this.http.get<any>(`${genesisServerUrl}getCurrentCredRate`);
    }

    claimStakingReward(body: object) {
        const httpOptions = {
            headers: new HttpHeaders({
                token: this.getAuthToken()
            })
        };

        return this.http.post<any>(
            `${genesisServerUrl}claimStakingReward`,
            body,
            httpOptions
        );
    }

    updateStakingRewardClaimSignature(body: object) {
        const httpOptions = {
            headers: new HttpHeaders({
                token: this.getAuthToken()
            })
        };

        return this.http.post<any>(
            `${genesisServerUrl}updateStakingRewardClaim`,
            body,
            httpOptions
        );
    }

    getReferralRewardStats(filter: string) {
        const httpOptions = {
            headers: new HttpHeaders({
                token: this.getAuthToken()
            })
        };

        return this.http.get<any>(
            `${genesisServerUrl}getReferralRewardStats?filter=${filter}`,
            httpOptions
        );
    }

    getReferralRewards(data: any) {
        const page = data.page;
        const limit = data.limit;

        const httpOptions = {
            headers: new HttpHeaders({
                token: this.getAuthToken()
            })
        };

        return this.http.get<any>(
            `${genesisServerUrl}getReferralRewards?page=${page}&limit=${limit}`,
            httpOptions
        );
    }

    getTopCredUsers(current_level: any) {
        const httpOptions = {
            headers: new HttpHeaders({
                token: this.getAuthToken()
            })
        };

        return this.http.get<any>(`${genesisServerUrl}getTopNodePurchaseUsers?level=${current_level}`, httpOptions);
    }

    getNodePurchaseStats(current_level: any) {
        const httpOptions = {
            headers: new HttpHeaders({
                token: this.getAuthToken()
            })
        };

        return this.http.get<any>(`${genesisServerUrl}getNodePurchaseStats?level=${current_level}`, httpOptions);
    }

    getNodePurchaseChart(current_level: any) {
        const httpOptions = {
            headers: new HttpHeaders({
                token: this.getAuthToken()
            })
        };

        return this.http.get<any>(`${genesisServerUrl}getNodePurchaseChart?level=${current_level}`, httpOptions);
    }

    getReferralBalance(currency: string) {
        const httpOptions = {
            headers: new HttpHeaders({
                token: this.getAuthToken()
            })
        };

        return this.http.get<any>(
            `${genesisServerUrl}getReferralBalance?currency=${currency}`,
            httpOptions
        );
    }

    claimReferralReward(body: object) {
        const httpOptions = {
            headers: new HttpHeaders({
                token: this.getAuthToken()
            })
        };

        return this.http.post<any>(
            `${genesisServerUrl}claimReferralReward`,
            body,
            httpOptions
        );
    }

    updateReferralRewardClaim(body: object) {
        const httpOptions = {
            headers: new HttpHeaders({
                token: this.getAuthToken()
            })
        };

        return this.http.post<any>(
            `${genesisServerUrl}updateReferralRewardClaim`,
            body,
            httpOptions
        );
    }

    getReferralRewardWithdrawals(data: any) {
        const httpOptions = {
            headers: new HttpHeaders({
                token: this.getAuthToken()
            })
        };

        return this.http.get<any>(
            `${genesisServerUrl}getReferralRewardWithdrawals?page=${data.page}&limit=${data.limit}`,
            httpOptions
        );
    }

    getStakingRewardWithdrawals(data: any) {
        const httpOptions = {
            headers: new HttpHeaders({
                token: this.getAuthToken()
            })
        };

        return this.http.get<any>(
            `${genesisServerUrl}getStakingRewardWithdrawals?page=${data.page}&limit=${data.limit}`,
            httpOptions
        );
    }
}
